@if (isVisible) {
  <img src="assets/template2/images/spinner.gif" style="height: 30px;" alt="">
}
